import { useState, useEffect } from 'react'
import { apiGet } from '../../generic/Api_Functions'
import { Typography } from '@mui/material'

const License = () => {
  const [licenses, setLicenses] = useState([])

  useEffect(() => {
    const fetchLicenses = async () => {
      try {
        const result = await apiGet('license')
        setLicenses(result || [])
      } catch (error) {
        console.error('Failed to fetch licenses:', error)
      }
    }
    fetchLicenses()
  }, [])

  const licenseNames = licenses.map(license => license.name).join(' & ')

  return (
    <Typography variant='body2' textAlign='center'>
      License: {licenseNames || 'No licenses available'}
    </Typography>
  )
}

export default License
